import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page main">
        <div className="cart-container empty">
          <h1 className="cart-title">Shopping Cart</h1>
          <p>Your cart is currently empty.</p>
          <Link onClick={toTop} to="/shop" className="continue-shopping">
            Continue Shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page main">
      <div className="cart-container">
        <h1 className="cart-title">Shopping Cart</h1>

        <div className="cart-items">
          {cartItems.map((item, index) => {
            const product = getProductById(item.id);
            if (!product) return null;

            return (
              <div className="cart-item" key={index}>
                <div className="item-image">
                  <img src={product.image} alt={product.name} />
                </div>

                <div className="item-details">
                  <h3 className="item-name">{product.name}</h3>
                  <div className="item-variant">
                    {item.color && <span>Envelopes: {item.color}</span>}
                  </div>
                </div>

                <div className="item-controls">
                  <div className="quantity-control">
                    <button
                      onClick={() =>
                        handleUpdateQuantity(
                          item.id,
                          item.size,
                          item.color,
                          item.quantity - 1
                        )
                      }
                    >
                      -
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      onClick={() =>
                        handleUpdateQuantity(
                          item.id,
                          item.size,
                          item.color,
                          item.quantity + 1
                        )
                      }
                    >
                      +
                    </button>
                  </div>

                  <div className="item-price">
                    ${Number(product.price).toFixed(2)}
                  </div>

                  <button
                    className="remove-btn"
                    onClick={() =>
                      removeFromCart(item.id, item.size, item.color)
                    }
                  >
                    &times;
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        <div className="cart-summary">
          <div className="subtotal-row">
            <span className="subtotal-label">Subtotal</span>
            <span className="subtotal-value">${subtotal.toFixed(2)}</span>
          </div>

          <button className="checkout-btn" onClick={handleCheckout}>
            CHECKOUT
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
